'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgHourglass(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("path", { d: "M9.886 2c.903 0 1.644.7 1.71 1.586l.004.128V5.25c0 .19-.063.373-.177.522l-.075.085L9.2 8l2.145 2.156a.857.857 0 01.242.49l.008.113.002 1.524c0 .906-.7 1.647-1.586 1.712L9.883 14H6.114c-.903 0-1.644-.7-1.71-1.586l-.004-.128v-1.531c0-.19.063-.372.177-.521l.074-.085L6.8 8 4.651 5.851a.857.857 0 01-.244-.493L4.4 5.245v-1.53c0-.904.7-1.645 1.586-1.71L6.114 2h3.772zM8.485 8.785a.686.686 0 00-.893-.067l-.077.067-1.714 1.714a.686.686 0 00-.192.377l-.009.108v1.13c0 .35.262.638.6.68l.086.006h3.428c.35 0 .638-.262.68-.6l.006-.086v-1.13a.686.686 0 00-.13-.402l-.07-.083-1.715-1.714zM9.715 3.2h-3.43a.686.686 0 00-.68.6l-.005.086V4.4h4.8v-.514a.686.686 0 00-.6-.68L9.714 3.2z", fill: "currentColor", fillRule: "evenodd" })));
}

module.exports = SvgHourglass;
//# sourceMappingURL=Hourglass.js.map
